import Emitter from "./Emitter";

export default class OpenCashier extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({event: "showDeposit"});
    }

    RELAX_handler() {
        this.emitParent({event: "showDeposit"});
    }

    IGT_handler() {
        this.emitParent({event: "showDeposit"});
    }

    GAMEIOM_handler() {
        this.emitParent(JSON.stringify({ wrapperAction:"gotoDepositPage" }));
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('openpage')) {
            const data =  {
                _type: "ucip.openpage.g2wOpenPageCommand",
                pageID: "deposit",
                url: this.gb.queryParams.cashierUrl,
            }

            if (this.gb.settings.nativeMobileApp) {
                data.handled = true;
                window.parent.postMessage(JSON.stringify(data));
                
            } else {
                this.emitParent(JSON.stringify(data))
            }
        }
    }

    MGS_handler() {
        this.emitParent('{"Name" : "launch_banking", "Origin" : "embeddedgame"}');
    }

    BETCONSTRUCT_handler() {
        if (this.gb.utils.isIframe === true && this.gb.queryParams && this.gb.queryParams.cashierUrl !== undefined) {
            window.open(decodeURIComponent(this.gb.queryParams.cashierUrl), '_blank');
        } else if (this.gb.utils.isIframe === true) {
            this.emitParent({ message: "cashier", param: null});
            this.emitTop({ wpgaction: "cashier" });
            this.emitParent({ wpgaction: "cashier.parent" });
        } else {
            if (this.gb.queryParams && this.gb.queryParams.cashierUrl !== undefined) {
                window.location = decodeURIComponent(this.gb.queryParams.cashierUrl);
            }
        }
    }

    POKERSTARS_handler() {
        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcUIElementClicked", "elementId":"cashier"}), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcUIElementClicked", "elementId":"cashier"}), "*");
        }
    }

    _default() {
        if(this.gb.walletCode === "SOFTSWISS" && this.gb.utils.isIframe === true && this.gb.queryParams && this.gb.settings.cashierUrl !== undefined && this.gb.settings.cashierWindowTop ){
            this.emitParent({message: "cashier", param: null});
            this.emitTop({wpgaction: "cashier"});
            this.emitParent({wpgaction: "cashier.parent"});
            this.emitiOS({wpgaction: "cashier"});

            this.emitParent({message: "openCashier", param: null});
            this.emitTop({eventName: "openCashier"});
            this.emitParent({eventName: "openCashier.parent"});
            this.emitiOS({eventName: "openCashier"});
            window.top.location = decodeURIComponent(this.gb.settings.cashierUrl);
        }
        if (this.gb.utils.isIframe === true && this.gb.queryParams && this.gb.queryParams.cashierUrl !== undefined && this.gb.queryParams.cashierWindowTop) {
            this.emitParent({message: "cashier", param: null});
            this.emitTop({wpgaction: "cashier"});
            this.emitParent({wpgaction: "cashier.parent"});
            this.emitiOS({wpgaction: "cashier"});

            this.emitParent({message: "openCashier", param: null});
            this.emitTop({eventName: "openCashier"});
            this.emitParent({eventName: "openCashier.parent"});
            this.emitiOS({eventName: "openCashier"});
            window.top.location = decodeURIComponent(this.gb.queryParams.cashierUrl);
        } else if (this.gb.utils.isIframe === true && this.gb.queryParams && this.gb.queryParams.cashierUrl !== undefined) {
            this.emitParent({ message: "cashier", param: null});
            this.emitTop({ wpgaction: "cashier" });
            this.emitParent({ wpgaction: "cashier.parent" });
            this.emitiOS({ wpgaction: "cashier" });

            this.emitParent({ message: "openCashier", param: null});
            this.emitTop({ eventName: "openCashier" });
            this.emitParent({ eventName: "openCashier.parent" });
            this.emitiOS({ eventName: "openCashier" });
            window.location = decodeURIComponent(this.gb.queryParams.cashierUrl);
        } else if (this.gb.utils.isIframe === true) {
            this.emitParent({ message: "cashier", param: null});
            this.emitTop({ wpgaction: "cashier" });
            this.emitParent({ wpgaction: "cashier.parent" });
            this.emitiOS({ wpgaction: "cashier" });

            this.emitParent({ message: "openCashier", param: null});
            this.emitTop({ eventName: "openCashier" });
            this.emitParent({ eventName: "openCashier.parent" });
            this.emitiOS({ eventName: "openCashier" });
        } else {
            if (this.gb.queryParams && this.gb.queryParams.cashierUrl !== undefined && this.gb.queryParams.cashierWindowTop) {
                window.top.location = decodeURIComponent(this.gb.queryParams.cashierUrl);
            } else if (this.gb.queryParams && this.gb.queryParams.cashierUrl !== undefined) {
                window.location = decodeURIComponent(this.gb.queryParams.cashierUrl);
            }
        }
    }
}
